<template>
  <div class="dealership-applications-logs-list w-full min-w-0 max-w-full">
    <template v-if="isMobileDevice">
      <div v-if="items.length">
        <DealershipApplicationLogCard
          v-for="item of items"
          :id="item.id"
          :key="item.id"
          :event-type-label="item.eventTypeLabel"
          :comment="item.comment"
          :status-at-event="item.statusAtEvent"
          :user-data="item.userData"
          :created-at="item.createdAt"
        />
      </div>
      <SkeletonLoaderCard v-else :table-headers="tableHeaders" />
    </template>

    <OurTable
      v-else
      :headers="tableHeaders"
      :items="items"
      :table-fixed="false"
      class="dealership-applications-logs-list-table"
    >
      <template #cell-userData="{ value }">
        <div class="flex flex-col gap-1">
          <div>{{ value.fullName }}</div>
          <div>{{ value.email }}</div>
        </div>
      </template>
    </OurTable>
    <OurPagination
      v-if="isMoreThanOnePage"
      :current-page="paginationData.currentPage"
      :per-page="paginationData.perPage"
      :total="paginationData.total"
      @pageChange="onPageChange"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DealershipApplicationLogCard from "./DealershipApplicationLogCard.vue";
import SkeletonLoaderCard from "@/ui/loader/SkeletonLoaderCard.vue";

export default {
  name: "DealershipApplicationsLogsList",
  components: { DealershipApplicationLogCard, SkeletonLoaderCard },

  props: {
    items: {
      type: Array,
      default: () => [],
    },

    paginationData: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...mapGetters("breakpoint", ["isMobileDevice"]),

    tableHeaders() {
      const data = [
        {
          value: "id",
          text: this.$t("label.id"),
          thClass: "w-24",
          tdClass: "max-w-[4rem] min-w-[4rem]",
        },
        {
          value: "eventTypeLabel",
          text: this.$t("label.eventTypeLabel"),
          thClass: "w-[5rem]",
          tdClass: "max-w-[8rem] min-w-[8rem]",
        },
        {
          value: "comment",
          text: this.$t("label.comment"),
          thClass: "w-[5rem]",
          tdClass: "max-w-[24rem] min-w-[20rem]",
        },
        {
          value: "statusAtEvent",
          text: this.$t("label.statusAtEvent"),
          thClass: "w-[5rem]",
          tdClass: "max-w-[7rem] min-w-[7rem]",
        },
        {
          value: "userData",
          text: this.$t("label.userData"),
          thClass: "w-[5rem]",
          tdClass: "max-w-[12rem] min-w-[7rem]",
        },
        {
          value: "createdAt",
          text: this.$t("label.createdAtWithTime"),
          thClass: "w-[5rem]",
          tdClass: "max-w-[12rem] min-w-[7rem]",
        },
      ];

      return data;
    },

    isMoreThanOnePage() {
      return this.paginationData.lastPage > 1;
    },

    routePage() {
      return Number.parseInt(this.$route.query.page, 10) || 1;
    },
  },

  watch: {
    routePage(newPage) {
      if (newPage !== this.paginationData.currentPage) {
        this.$emit("pageChange", newPage);
      }
    },
  },

  methods: {
    onPageChange(page) {
      this.$emit("pageChange", page);

      if (page !== this.routePage) {
        const query = { ...this.$route.query };

        delete query.page;

        const nextQuery = page === 1 ? query : { ...query, page };

        this.$router.push({ name: this.$route.name, query: nextQuery });
      }
    },
  },
};
</script>
